import memberData from "./memberData";

const memberService = [
    {
        matcher: 'member',
        reply: config => {
            return [200, memberData];
        }
    }
]

export default memberService;